import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { TransportationReport } from "@/model/transportation-report/transportation-report"

export type DeepPartial<T> = {
    [P in keyof T]? : DeepPartial<T[P]>
}

export type TransportationReportState = {
    dialog: {
        open: boolean,
        initialValues: DeepPartial<TransportationReport>,
    }
}

const defaultDialogInitialValues: DeepPartial<TransportationReport> = {
    transportDetails: {
        transportMode: {
            type: "ROAD",
        }
    },
    shipments: [
        { volume: { unit: "CUBIC_METER" } }
    ]
}

export const initialState: TransportationReportState = {
    dialog: {
        open: false,
        initialValues: defaultDialogInitialValues,
    }
}

export const transportationReportSlice = createSlice({
    name: "transportationReport",
    initialState,
    reducers: {
        setDialogOpen: (state, action: PayloadAction<boolean>) => {
            const open = action.payload
            state.dialog.open = open
            if (!open) {
                state.dialog.initialValues = defaultDialogInitialValues
            }
        },
        setDialogInitialValues: (state, action: PayloadAction<DeepPartial<TransportationReport>>) => {
            state.dialog.initialValues = action.payload
        }
    }
})
